// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"118":"3c80f58e","416":"828cade4","467":"b2e4cc7e","657":"496b0266","693":"4ad1f7e2","737":"df8049ab"}[chunkId] + ".chunk.css";
};